import { apiFetch } from './client'
import { cached, invalidate } from './cache'

export interface MembershipPlan {
  id: string
  name: string
  description: string | null
  duration_days: number
  grace_days: number
  price: number
  is_active: boolean
  created_at: string
}

export interface CreatePlanInput {
  name: string
  description?: string
  durationDays: number
  graceDays: number
  price: number
}

export interface UpdatePlanInput {
  name?: string
  description?: string
  durationDays?: number
  graceDays?: number
  price?: number
  isActive?: boolean
}

export const listPlans = () =>
  cached('plans', () => apiFetch<{ plans: MembershipPlan[] }>('/membership-plans'), 300_000)

export const createPlan = async (data: CreatePlanInput) => {
  const r = await apiFetch<{ plan: MembershipPlan }>('/membership-plans', {
    method: 'POST',
    body: JSON.stringify(data),
  })
  invalidate('plans')
  return r
}

export const updatePlan = async (id: string, data: UpdatePlanInput) => {
  const r = await apiFetch<{ plan: MembershipPlan }>(`/membership-plans/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(data),
  })
  invalidate('plans')
  return r
}

export const deletePlan = async (id: string) => {
  const r = await apiFetch<{ ok: boolean }>(`/membership-plans/${id}`, { method: 'DELETE' })
  invalidate('plans')
  return r
}
